import { useLocation } from "react-router-dom";

import { ServiceRequest } from "../../../types/service.type";

import DetailsTab from "./DetailsTab";
import ChatTab from "./ChatTab";
import ContractTab from "./ContractTab";

const PageContentWrapper = ({
  serviceRequest,
  isServiceRequestLoading,
  handleSetIsContractPaid,
}: {
  serviceRequest?: ServiceRequest;
  isServiceRequestLoading: boolean;
  handleSetIsContractPaid: (isContractPaid: boolean) => void;
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  if (tab === "chat")
    return <ChatTab serviceProvider={serviceRequest?.serviceProvider} requester={serviceRequest?.requester} />;
  if (tab === "contract")
    return (
      <ContractTab
        serviceRequest={serviceRequest}
        isServiceRequestLoading={isServiceRequestLoading}
        handleSetIsContractPaid={handleSetIsContractPaid}
      />
    );

  return <DetailsTab serviceRequest={serviceRequest} isServiceRequestLoading={isServiceRequestLoading} />;
};

export default PageContentWrapper;
